import { Component, Inject, OnDestroy, OnInit, Input, Output } from '@angular/core';
import { Store } from '@src/store';
// import { projectActions } from "../../../../store/reducers/projectReducer";
import { environmentsActions } from '../../../../../store/reducers/environmentsReducer';
import { cmsActions } from '../../../../../store/reducers/cmsReducer';
import { projectsActions } from '../../../../../store/reducers/projectsReducer';
import { backupsActions } from '../../../../../store/reducers/backupsReducer';
import { packagesActions } from '../../../../../store/reducers/packagesReducer';
import { DialogManagerService } from '@src/services';
import _ from 'lodash';
import * as _str from 'underscore.string';
import moment from "moment";
import { consts } from '@src/constants/consts';
import { BuildDialogComponent } from "@app/shared/components/dialogs/build-dialog/build-dialog.component";
import { ValidateDialogComponent } from "@app/shared/components/dialogs/validate-dialog/validate-dialog.component";
import { SetTypeDialogComponent } from "@app/shared/components/dialogs/set-type-dialog/set-type-dialog.component";
import { RestoreBackupDialogComponent } from "@app/shared/components/dialogs/restore-backup-dialog/restore-backup-dialog.component";
import { BackupDialogComponent } from "@app/shared/components/dialogs/backup-dialog/backup-dialog.component";
import { BuildByTaskDialogComponent } from "@app/shared/components/dialogs/build-by-task-dialog/build-by-task-dialog.component";
import { ViewLabelDialogComponent } from "@app/shared/components/dialogs/view-label-dialog/view-label-dialog.component";
import { ApplyLabelDialogComponent } from "@app/shared/components/dialogs/apply-label-dialog/apply-label-dialog.component";
import { UpgradePreValidateToVersionDialogComponent } from "@app/shared/components/dialogs/upgrade-prevalidate-to-version-dialog/upgrade-prevalidate-to-version-dialog.component";
import { RollbackToVersionDialogComponent } from "@app/shared/components/dialogs/rollback-to-version-dialog/rollback-to-version-dialog.component";
import { SetVersionDialogComponent } from "@app/shared/components/dialogs/set-version-dialog/set-version-dialog.component";
import { EventEmitter } from '@angular/core';
//import { EventListener } from '@angular/core/src/debug/debug_node';

@Component({
    selector: 'environment-type',
    template: require('./environmentType.html'),
    styles: [require('./_environmentType.scss')]
})

export class EnvironmentTypeComponent implements OnInit, OnDestroy {

    @Input() public projectData;
    @Input() public RMid;
    @Input() public set environments(value) {

        const tempEnvironments = _.orderBy(value, ["name"], ["asc"]);
        this._environments = tempEnvironments.map((env) => ({ ...env }));
    }
    @Input() public hasAutoDrift: any;
    @Input() public titleText: any;
    @Input() public envTypeTest: any;
    @Input() public envType: any;
    @Input() public envConfig: any;
    @Input() public index: any;
    @Input() public UseDowngradeScripts: boolean = true;

    @Output() public onGetRmId = new EventEmitter();
    @Output() public onEditModeDblClick = new EventEmitter();
    @Output() public onEnvDblClick = new EventEmitter();
    @Output() public onEditModeDblClickTest = new EventEmitter();

    public _environments: any;
    public packagesData: any;
    public pageId = 1;
    public quantity = 15;
    public autoBackupsItems = [];
    public autoRestoreItems = [];
    public autoRestoreSelected;
    public autoBackupSelected;
    public defaultBackup;
    public defaultAutoRestore;
    public dbFlags;

    public projectId: any;
    public scrollEnvs;
    public dplModeType: any;
    public search: any;
    public $translate: any;

    constructor(
        @Inject("$q") private $q: any,
        @Inject("$filter") private $filter: any,
        private dialogManagerService: DialogManagerService,
        @Inject("dbTypeService") private dbTypeService: any,
        @Inject("$scope") public $scope: any,
        public store: Store,
        @Inject("$state") public state: any,
        @Inject("$stateParams") public $stateParams: any
    ) {
        this.projectId = this.$stateParams.id;
        this.$translate = this.$filter("translate");
    }

    ngOnInit() {
        this.UseDowngradeScripts = true;
        if (this.projectId && this.projectId !== "0") {
            if (!this.store.getState().projects.projectWithMetaData ||
                (this.store.getState().projects.projectWithMetaData && this.store.getState().projects.projectWithMetaData.id !== this.projectId)) {
                this.store.dispatch({ type: projectsActions.GET_PROJECT_META_DATA, payload: { projId: this.projectId } })
                    .then(resp => {
                        let data = { ...resp.data };
                        this.dplModeType = data.dplModeType;
                        if (data && data.options) {
                            this.UseDowngradeScripts = data.options.UseDowngradeScripts;
                        }
                    });
            } else {
                this.dplModeType = this.store.getState().projects.projectWithMetaData.dplModeType;
            }
        }



    }

    async onBuild(environmentData) {
        let environment = environmentData.data;
        this.store.dispatch({
            type: packagesActions.GET_NEXT_REGULAR_PACKAGE_NAME,
            payload: { projectId: this.projectId }
        })
        let sourceManage = [
            //    { name: "Live Version", id: "1" },
            //    { name: "Latest Checkins", id: "0" },            
        ];

        //no use for now for sourceUnmanaged
        //let sourceUnManage = [{ name: "Live Version", id: "1" }];
        this.onGetRmId.emit("true");
        //let rmId = this.RMid;
        await this.store.dispatch({
            type: projectsActions.GET_PROJECT_META_DATA,
            payload: { projId: this.projectId }
        });
        let requests = [];
        // this.store.getState().packageManager.deployedPackages.packages = null;
        requests.push(this.store.dispatch({ type: packagesActions.GET_PACKAGES_OF_ENV_BUILD, payload: { projectId: this.projectId, envID: this.RMid } }));
        const unsubscribe = this.store.subscribe(() => {
            if (this.store.getState().packageManager.deployedPackages.packages) {
                this.packagesData = this.store.getState().packageManager.deployedPackages.packages;
                this.packagesData = _.filter(this.packagesData, (item) => item.packageState && !item.isTemporary);
                this.packagesData = _.uniqBy(this.packagesData, 'id');
                unsubscribe();
            }
        });
        requests.push(this.store.dispatch({ type: environmentsActions.GET_ENV_SETTINGS, payload: { projectId: this.projectId, envId: environment.id } }));
        await this.store.dispatch({
            type: projectsActions.GET_PROJECT_META_DATA,
            payload: { projId: this.projectId }
        });
        //Add all comparison types we got from the server (TODO: change to ComparisonTypes)
        sourceManage = this.store.getState().environments.envSettings.comparisonTypes;

        this.$q.all(requests).then((resp) => {

            const dbTypeID = this.store.getState().projects.projectWithMetaData.dbTypeId;;
            const versionName = this.store.getState().packageManager.nextRegularPackage;

            const onConfirm = (data) => {
                this.store.dispatch({
                    type: environmentsActions.BUILD,
                    payload: {
                        projectId: this.projectId,
                        envId: environment.id,
                        params: {
                            sourceLabel: null,
                            targetEnvId: null,
                            targetLabel: null,
                            packageName:
                                data.baselineSelected && data.baselineSelected != "None"
                                    ? data.baselineSelected
                                    : null,
                            sourceComparisonType: data.sourceSelected,
                            targetComparisonType: data.targetSelected,
                            targetPackageName: data.createPackage
                                ? data.versionName
                                    ? data.versionName
                                    : ""
                                : "",
                            additionalInfo: data.additionalInfo,
                            createDowngradeScripts: data.createDowngradeScripts,
                        },
                    },
                });
            };
            //use only the manage source. The list is defined by the server.
            let selectedSourceId = sourceManage?.[this.getSourceSelected(resp[1])]?.id;
            const dialogData = {
                title: "Build",
                sourceSelected: selectedSourceId,
                //sources: (environment.isManaged) ? sourceManage: sourceUnManage,
                sources: sourceManage,
                versionName: environment.isManaged ? "" : versionName,
                packages: this.packagesData,
                targets: [{ name: "Latest Label", id: "6" }, { name: "Live Version", id: "1" }],
                dbTypeId: dbTypeID,
                targetSelected: "6",
                baselineSelected: "None",
                additionalInfo: "",
                createDowngradeScripts: this.UseDowngradeScripts,
                store: this.store,
                projectId: this.projectId,
                browseButton: {
                    value: "Browse",
                    onClick: (data) => {
                        this.HandleFileButtonClick(data);
                        data.selectedFile = data.selectedFile;
                    },
                },
            };
            dialogData.store = this.store;
            this.dialogManagerService.showDialog(
                dialogData,
                onConfirm,
                BuildDialogComponent,
                "build-dialog"
            );
            return resp;
        });
    }

    onBuildByTask(environmentData) {
        let action = environmentData.type;
        let environment = environmentData.data;
        if (action) { }
        let requests = [];
        requests.push(this.store.dispatch({ type: cmsActions.GET_CHECKIN_TASKS_BY_PROJECT_ID, payload: { projectId: this.projectId } }));
        requests.push(this.store.dispatch({ type: cmsActions.GET_QUERIES, payload: { projectId: this.projectId, } }));
        this.$q.all(requests).then((resp) => {
            let queries = (resp.length > 1) ? resp[1] : null;
            this.buildTaskPop(resp[0], queries, environment);
        });
    }

    buildTaskPop(tasks, _queries, environment) {
        const _this = this;
        this.search = false;
        tasks = tasks.map(item => {
            item.id = item.taskId;
            return item;
        });
        if (tasks.length > 0) {

            const onConfirm = (data) => {
                const ids = data.selectedTasksForBuild.map(item => item.id)
                this.store.dispatch({
                    type: environmentsActions.BUILDBYTASK,
                    payload: {
                        projectId: _this.projectId,
                        envId: environment.id,
                        params: {
                            "sourceEnvId": environment.id,
                            "targetEnvId": null,
                            "taskIds": (ids) ? ids.toString() : null
                        }
                    }
                });
            }
            const dialogData = {
                title: 'Build By Task',
                tasks,
                queries: _queries,
                selectedTasksForBuild: [],
                projectId: this.projectId
            };
            this.dialogManagerService.showDialog(dialogData, onConfirm, BuildByTaskDialogComponent, 'build-by-task-dialog');
        } else {
            this.dialogManagerService.showErrorDialog({ title: '', text: this.$translate("ERROR_NO_CMS_TASKS") });
        }
    }

    getSourceSelected(resp) {
        let result = resp.data.comparisonTypes.filter(obj => obj.isSelected == "True");
        if (result && result.length == 1) {
            return result[0].id;
        }
        return 0;
    }

    onViewLabel(environmentData) {
        let environment = environmentData.data
        const requests = [];
        requests.push(this.store.dispatch({ type: environmentsActions.GET_LABELS, payload: { projectId: this.projectId, envId: environment.id } }));
        requests.push(this.store.dispatch({ type: environmentsActions.GET_ENV_SCHEMA, payload: { projectId: this.projectId, envId: environment.id } }));
        this.$q.all(requests).then(resp => {
            let labels = [...resp[0].data];
            labels.forEach(m => {
                m.description = m.description.includes('System') ? "System label - please don\'t delete" : m.description
                m.creationDate = this.convertUTCtoLocal(m.creationDate);
            })

            const dialogData = {
                title: 'View label',
                labels: labels
            };
            this.dialogManagerService.showDialog(dialogData, () => { }, ViewLabelDialogComponent, 'view-label-dialog');

        });
    }



    getLablesAndPackages = (environment, actionLabels, actionPackages) => {
        return Promise.all([
            this.store.dispatch({ type: actionLabels, payload: { projectId: this.projectId, envId: environment.id, } }),
            this.store.dispatch({ type: actionPackages, payload: { projectId: this.projectId, envId: environment.id, } })
        ]);
    }

    onValidateLabels(environmentData) {
        let environment = environmentData.data
        this.onGetRmId.emit("true");
        this.getLablesAndPackages(environment, environmentsActions.GET_LABELS_FOR_VALIDATE, environmentsActions.GET_PACKAGES_FOR_VALIDATE).then((resp) => {
            const packs = resp.find(m => { return m.type === environmentsActions.GET_PACKAGES_FOR_VALIDATE }).data;
            const lables = resp.find(m => { return m.type === environmentsActions.GET_LABELS_FOR_VALIDATE }).data;
            let labelsCloned = _.cloneDeep(lables);
            let packsCloned = _.cloneDeep(packs);
            const foundPackage = packsCloned.find(m => m.name === environment.version);
            const selected = foundPackage ? foundPackage.id : -1;
            const onConfirm = (data) => {
                if (this.isMissingPackageOrLable(data.selected, data.selectedAction)) {
                    const type = (data.selectedAction === consts.actionType.ByLabel) ? environmentsActions.VALIDATE_BY_LABEL : environmentsActions.VALIDATE_BY_PACKAGE;
                    this.store.dispatch({
                        type: type,
                        payload: { projectId: this.projectId, envId: environment.id, validateTypeId: data.selected }
                    });
                }
            };

            const dialogData = {
                title: 'Validate',
                labels: labelsCloned,
                packages: packsCloned,
                envName: environment.name,
                selected: selected,
                actions: consts.actionType,
                selectedAction: this.IsByTask() ? consts.actionType.ByLabel : consts.actionType.ByPackage
            };
            this.dialogManagerService.showDialog(dialogData, onConfirm, ValidateDialogComponent, 'validate-dialog');

            return resp;
        });
    }

    async onRollBack(environmentData) {
        let environment = environmentData.data
        const tempDbTypeId = this.store.getState().projects.projectWithMetaData.dbTypeId;
        this.dbFlags = await this.dbTypeService.getFlags(tempDbTypeId);
        this.store.dispatch({ type: backupsActions.GET_BACKUPS_ACTIONS, payload: { data: { EnvironmentId: environment.id } } })
            .then(resp => {
                this.defaultBackup = resp.filter(env => env.IsDefault);
                if (this.defaultBackup.length === 0) {
                    resp[0].IsDefault = true;
                    this.defaultBackup = [resp[0]];
                }
                resp = resp.filter(env => !env.IsDefault);
                this.autoBackupsItems = [{ Key: this.defaultBackup[0].Key, Value: this.defaultBackup[0].Value }, ...resp];
            })
        this.store.dispatch({ type: backupsActions.GET_RESTORE_ACTIONS, payload: { data: { EnvironmentId: environment.id } } })
            .then(resp => {
                this.defaultAutoRestore = resp.filter(env => env.IsDefault);
                if (this.defaultAutoRestore.length === 0) {
                    resp[0].IsDefault = true;
                    this.defaultAutoRestore = [resp[0]];
                }
                resp = resp.filter(env => !env.IsDefault);
                this.autoRestoreItems = [{ Key: this.defaultAutoRestore[0].Key, Value: this.defaultAutoRestore[0].Value }, ...resp];
            })
            .then(() => {
                if (this.IsByTask() && this.UseDowngradeScripts) {
                    const date = new Date().toISOString();
                    this.store.dispatch({
                        type: environmentsActions.GET_PACKAGES_FOR_ROLLBACK_BY_TASK,
                        payload: {
                            projectId: this.projectId,
                            envId: environment.id,
                            pageNumber: 0,
                            pageSize: 10,
                            startDate: date,
                            endDate: date,
                            filterText: '',
                            filterOption: 2,
                            displayAdHocs: true
                        }
                    })
                        .then(resp => {
                            //const { data } = { ...resp };
                            const data = { ...resp };
                            if (data && data.length === 0) {
                                this.dialogManagerService.showErrorDialog({ title: '', text: this.$translate("ERROR_PACKAGE_NOT_EXIST") });
                            } else {
                                this.dialogManagerService.showMultiRollbackPackageDialog({
                                    dispatch: (action) => this.store.dispatch(action),
                                    project: { projectId: this.projectId },
                                    environment: { name: environment.name, version: environment.version, id: environment.id },
                                    packages: { selectedPackages: [], availablePackages: [] },
                                    autoBackUpItems: this.autoBackupsItems,
                                    autoRestoreItems: this.autoRestoreItems,
                                    autoBackupSelected: data && data.autoBackupSelected ? data.autoBackupSelected : null,
                                    autoRestoreSelected: data && data.autoRestoreSelected ? data.autoRestoreSelected : null,
                                    withScript: false,
                                    dbFlags: this.dbFlags
                                }, async (data) => {
                                    const packages = data.packages.selectedPackages.map((x) => ({ packageId: x.id, order: x.order }));
                                    const packagesDowngrade = _.orderBy(packages, ['order'], ['asc']);
                                    await this.store.dispatch({
                                        type: environmentsActions.ROLLBACK_DOWNGRADE_BY_TASK,
                                        payload: {
                                            createScriptOnly: data.withScript,
                                            projectId: data.project.projectId,
                                            envId: data.environment.id,
                                            body: {
                                                restoreBehavior: data.autoRestoreSelected === "" ? null : parseInt(data.autoRestoreSelected),
                                                backupBehavior: data.autoBackupSelected === "" ? null : parseInt(data.autoBackupSelected),
                                                packagesDowngrade


                                            }
                                        }
                                    });
                                });
                            }
                        });
                }
                else {
                    this.getLablesAndPackages(environment, environmentsActions.GET_LABELS_FOR_ROLLBACK, environmentsActions.GET_PACKAGES_FOR_ROLLBACK).then((resp) => {
                        const onConfirm = (data) => {
                            if (this.isMissingPackageOrLable(data.selected, data.selectedAction)) {
                                const type = (data.selectedAction === 'ByLabel') ? environmentsActions.ROLLBACK_BY_LABEL : environmentsActions.ROLLBACK;
                                this.store.dispatch({
                                    type: type,
                                    payload: {
                                        projectId: this.projectId,
                                        envId: environment.id,
                                        rollbackTypeId: data.selected,
                                        body: {
                                            restoreBehavior: data.autoRestoreSelected === "" ? null : parseInt(data.autoRestoreSelected),
                                            backupBehavior: data.autoBackupSelected === "" ? null : parseInt(data.autoBackupSelected),
                                            createScriptOnly: data.withScript

                                        }
                                    }
                                });
                            }
                        };
                        const packs = resp.find(m => { return m.type === environmentsActions.GET_PACKAGES_FOR_ROLLBACK }).data;
                        const lables = resp.find(m => { return m.type === environmentsActions.GET_LABELS_FOR_ROLLBACK }).data;
                        let packsCloned = _.cloneDeep(packs);
                        let labelsCloned = _.cloneDeep(lables);
                        const dialogData = {
                            title: 'Downgrade/Rollback',
                            envName: environment.name,
                            version: environment.version,
                            withScript: false,
                            labels: labelsCloned,
                            byactions: packsCloned,
                            packages: packsCloned,
                            actions: tempDbTypeId === 9 ? { ByPackage: 'By Package' } : consts.actionType,
                            selectedAction: this.IsByTask() ? consts.actionType.ByLabel : consts.actionType.ByPackage,
                            autoBackUpItems: this.autoBackupsItems,
                            autoRestoreItems: this.autoRestoreItems,
                            dbFlags: this.dbFlags
                        };
                        this.dialogManagerService.showDialog(dialogData, onConfirm, RollbackToVersionDialogComponent, 'rollback-to-version-dialog');

                        return resp;
                    });
                }
            })

    }
    getRmId($event) {
        this.onGetRmId.emit($event);
    }

    isMissingPackageOrLable = (selected, selectedType) => {
        if (!selected || selected.toString().trim().length === 0) {
            this.dialogManagerService.showErrorDialog({
                title: '',
                text: _str.sprintf(this.$translate("NO_LABEL_PACKAGE_SELECTED"), selectedType.toLowerCase())
            });
            return false;
        }
        return true;
    }

    onBackupEnvironment(environmentData) {
        let environment = environmentData.data;
        const currentTime = new Date();
        const now = currentTime.getHours() + ":" + currentTime.getMinutes() + ":" + currentTime.getSeconds();
        let envStringName = environment.name + '_' + environment.version + '_' + now;

        const dialogData = {
            title: 'Backup Environment',
            backupName: envStringName,
            isDev: environment.isDev,
            isForceBackup: false
        };
        const onConfirm = (data) => {
            this.store.dispatch({
                type: backupsActions.BACKUP_ENVIRONMENT,
                payload: {
                    data: {
                        projectId: this.projectId,
                        environmentId: environment.id,
                        backupName: data.backupName,
                        forceBackup: data.isForceBackup,
                        backupDescription: data.description ? data.description : null,
                        saveDeployedPackagesOnly: data.saveDeployedPackagesOnly
                    }
                }
            }).then((envType) => {
                if (data.saveDeployedPackagesOnly) {
                    this.dialogManagerService.showSuccessDialog({ title: 'Backup Environment Completed Successfully', text: '' });
                }
                return envType;
            });
        }
        this.dialogManagerService.showDialog(dialogData, onConfirm, BackupDialogComponent, 'backup-dialog');
    }

    onRestoreEnvironment(environmentData) {
        let environment = environmentData.data;
        var payload = {
            "pipelineId": parseInt(this.projectId),
            "environmentId": [environment.id],
            "environmentTypeId": null,
            "pageNumber": this.pageId,
            "pageCount": 1000,
            "startTime": null,
            "endTime": null
        }
        this.store.dispatch({
            type: backupsActions.GET_BACKUPS_FOR_RESTORE,
            payload: { data: payload }
        })
            .then(resp => {
                //in case there are no backups
                if (resp.length === 0) {
                    this.dialogManagerService.showErrorDialog({ title: '', text: this.$translate("ERROR_BACKUP_NOT_EXIST") });
                } else {
                    //if there are backups
                    // this.pageId++;
                    const dialogData = {
                        title: 'Select Backup',
                        envId: environment.id,
                        envName: environment.name,
                        envVersion: environment.version,
                        isForceRestore: false,
                        items: resp
                    };
                    const onConfirm = (data) => {
                        this.store.dispatch({
                            type: backupsActions.RESTORE_ENVIRONMENTS,
                            payload: {
                                projectId: this.projectId,
                                targetEnvId: environment.id,
                                backupId: data.selected.id,
                                force: data.isForceRestore,
                                restoreDeployedPackagesOnly: data.restoreDeployedPackagesOnly
                            }
                        }).then((envType) => {
                            if (data.restoreDeployedPackagesOnly) {
                                this.dialogManagerService.showSuccessDialog({ title: 'Restore Environment Completed Successfully', text: '' });
                            }
                            return envType;
                        })
                    }
                    this.dialogManagerService.showDialog(dialogData, onConfirm, RestoreBackupDialogComponent, 'restore-backup-dialog');
                    return resp;
                }
            });

    }

    onApplyLabel(environmentData) {
        let environment = environmentData.data
        const dialogData = {
            title: 'Apply Label',
            envName: environment.name
        };
        const onConfirm = (data) => {
            if (!data.label || data.label.trim().length === 0) {
                this.dialogManagerService.showErrorDialog({ title: '', text: this.$translate("ERROR_APPLY_LABEL_EMPTY") });
            } else {
                this.store.dispatch({
                    type: environmentsActions.APPLY_LABEL,
                    payload: {
                        projectId: this.projectId,
                        envId: environment.id,
                        labelName: data.label,
                        labelDesc: data.desc
                    }
                });
            }
        }
        this.dialogManagerService.showDialog(dialogData, onConfirm, ApplyLabelDialogComponent, 'apply-label-dialog');
    }

    onSetType(environmentData) {
        let environment = environmentData.data
        this.store.dispatch({ type: environmentsActions.GET_ENV_TYPES }).then((envType) => {
            const onConfirm = () => {
                this.store.dispatch({
                    type: environmentsActions.SET_TYPE,
                    payload: { projectId: this.projectId, envId: environment.id, id: environment.selected }
                });
            }
            const dialogData = {
                title: 'Set Type',
                envTypes: envType.data
            };
            this.dialogManagerService.showDialog(dialogData, onConfirm, SetTypeDialogComponent, 'set-type-dialog');
            return envType;
        })
    }

    convertUTCtoLocal(date) {
        return date ? moment.utc(date).local().format('YYYY-DD-MM HH:mm:ss') : '';
    }

    async onUpdate(environmentData) {
        let environment = environmentData.data;
        let type = environmentData?.type
        const tempDbTypeId = this.store.getState().projects.projectWithMetaData.dbTypeId;
        this.dbFlags = await this.dbTypeService.getFlags(tempDbTypeId);

        //TODO: Check why the Publish removed the IsDefault property from Backup and Restore actions
        await this.store.dispatch({ type: backupsActions.GET_BACKUPS_ACTIONS, payload: { data: { EnvironmentId: environment.id } } })
            .then(resp => {
                this.defaultBackup = resp.filter(env => env.IsDefault);
                if (this.defaultBackup.length === 0) {
                    resp[0].IsDefault = true;
                    this.defaultBackup = [resp[0]];
                }
                resp = resp.filter(env => !env.IsDefault);
                this.autoBackupsItems = [{ Key: this.defaultBackup[0].Key, Value: this.defaultBackup[0].Value }, ...resp];
            })
        await this.store.dispatch({ type: backupsActions.GET_RESTORE_ACTIONS, payload: { data: { EnvironmentId: environment.id } } })
            .then(resp => {
                this.defaultAutoRestore = resp.filter(env => env.IsDefault);
                if (this.defaultAutoRestore.length === 0) {
                    resp[0].IsDefault = true;
                    this.defaultAutoRestore = [resp[0]];
                }
                resp = resp.filter(env => !env.IsDefault);
                this.autoRestoreItems = [{ Key: this.defaultAutoRestore[0].Key, Value: this.defaultAutoRestore[0].Value }, ...resp];
            })

        let backupsType = [];
        //checks if this environment already called to get the backup actions
        if (environment.id === this.store.getState().backups.environmentId && this.store.getState().backups.backActions.length !== 0) {
            let backActions = this.store.getState().backups.backActions;
            this.defaultBackup = backActions.filter(env => env.IsDefault);
            backActions = backActions.filter(env => !env.IsDefault);
            if (this.defaultBackup.length !== 0)
                this.autoBackupsItems = [{ Key: this.defaultBackup[0].Key, Value: this.defaultBackup[0].Value }, ...backActions];
            else {
                this.defaultBackup = backActions.shift();
                this.autoBackupsItems = [{ Key: this.defaultBackup.Key, Value: this.defaultBackup.Value }, ...backActions];
            }
        } else {
            backupsType = await this.store.dispatch({
                type: backupsActions.GET_BACKUPS_ACTIONS,
                payload: { data: { EnvironmentId: environment.id } }
            })
            if (!backupsType) {
                return;
            }
            this.defaultBackup = backupsType.filter(env => env.IsDefault);
            backupsType = backupsType.filter(env => !env.IsDefault);
            if (this.defaultBackup.length !== 0)
                this.autoBackupsItems = [{
                    Key: this.defaultBackup[0].Key,
                    Value: this.defaultBackup[0].Value
                }, ...backupsType];
            else {
                this.defaultBackup = backupsType.shift();
                this.autoBackupsItems = [{
                    Key: this.defaultBackup.Key,
                    Value: this.defaultBackup.Value
                }, ...backupsType];
            }
        }
        //checks if this environment already called to get the restore actions
        if (environment.id === this.store.getState().backups.environmentId && this.store.getState().backups.restoreActions.length !== 0) {
            let restoreActions = this.store.getState().backups.restoreActions;
            this.defaultAutoRestore = restoreActions.filter(env => env.IsDefault);
            restoreActions = restoreActions.filter(env => !env.IsDefault);
            if (this.defaultAutoRestore.length !== 0)
                this.autoRestoreItems = [{ Key: this.defaultAutoRestore[0].Key, Value: this.defaultAutoRestore[0].Value }, ...restoreActions];
            else {
                this.defaultAutoRestore = backupsType.shift();
                this.autoRestoreItems = [{ Key: this.defaultAutoRestore.Key, Value: this.defaultAutoRestore.Value }, ...restoreActions];
            }
            if (this.IsByTask()) {
                this.UpgradePreValidateByTask(environment, type);
            } else {
                this.UpgradePreValidateByVersion(environment, type);
            }
        } else {
            this.store.dispatch({ type: backupsActions.GET_RESTORE_ACTIONS, payload: { data: { EnvironmentId: environment.id } } })
                .then(resp => {
                    this.defaultAutoRestore = resp.filter(env => env.IsDefault);
                    resp = resp.filter(env => !env.IsDefault);
                    if (this.defaultAutoRestore.length !== 0)
                        this.autoRestoreItems = [{ Key: this.defaultAutoRestore[0].Key, Value: this.defaultAutoRestore[0].Value }, ...resp];
                    else {
                        this.defaultAutoRestore = resp.shift();
                        this.autoRestoreItems = [{ Key: this.defaultAutoRestore.Key, Value: this.defaultAutoRestore.Value }, ...resp];
                    }
                }).then(() => {
                    if (this.IsByTask()) {
                        this.UpgradePreValidateByTask(environment, type);
                    } else {
                        this.UpgradePreValidateByVersion(environment, type);
                    }
                })
            this.store.dispatch({ type: backupsActions.SET_BACKUP_ENVIRONMENT, payload: { environmentId: environment.id } });
        }
    }

    UpgradePreValidateByTask = (environment, type) => {
        const date = new Date().toISOString();
        this.store.dispatch({
            type: environmentsActions.GET_PACKAGES_FOR_DEPLOY_BY_TASK,
            payload: {
                projectId: this.projectId,
                envId: environment.id,
                pageNumber: 0,
                pageSize: 1,
                startDate: date,
                endDate: date,
                filterText: '',
                filterOption: 2,
                displayAdHocs: true
            }
        })
            .then(resp => {
                // {data} remmber this point
                const data = { ...resp };
                if (data && data.length === 0) {
                    this.dialogManagerService.showErrorDialog({ title: '', text: this.$translate("ERROR_PACKAGE_NOT_EXIST") });
                } else {
                    this.dialogManagerService.showMultiUpgradePreVaildatePackageDialog({
                        title: type,
                        dispatch: (action) => this.store.dispatch(action),
                        project: { projectId: this.projectId },
                        environment: { name: environment.name, version: environment.version, id: environment.id },
                        packages: { selectedPackages: [], availablePackages: [] },
                        autoBackUpItems: this.autoBackupsItems,
                        autoRestoreItems: this.autoRestoreItems,
                        autoBackupSelected: data && data.autoBackupSelected ? data.autoBackupSelected : null,
                        autoRestoreSelected: data && data.autoRestoreSelected ? data.autoRestoreSelected : null,
                        dbFlags: this.dbFlags
                    });
                }
            });
    }

    UpgradePreValidateByVersion = (environment, type) => {
        this.store.dispatch({ type: environmentsActions.GET_VERSIONS_FOR_UPGRADE, payload: { projectId: this.projectId, envId: environment.id } }).then((resp) => {
            if (resp.data.length == 0) {
                this.dialogManagerService.showErrorDialog({ title: '', text: this.$translate("ERROR_PACKAGE_NOT_EXIST") });
            } else {

                const onConfirm = (data) => {
                    const onUpgradePreValidateConfirm = () => {
                        this.store.dispatch({
                            type: environmentsActions.UPGRADE_PREVALIDATE_TO_VERSION,
                            payload: {
                                type: type === 'Upgrade' ? 'Update' : 'PreCheck',
                                projectId: this.projectId,
                                envId: environment.id,
                                packageId: data.selectedVersion,
                                body: {
                                    backupBehavior: data.autoBackupSelected === "" ? null : parseInt(data.autoBackupSelected),
                                    restoreBehavior: data.autoRestoreSelected === "" ? null : parseInt(data.autoRestoreSelected)
                                }
                            }
                        });
                    }

                    const dialogData = {
                        title: type + ' Package',
                        action: type,
                        objectType: 'package',
                        item: data.versions.find(ver => ver.id === data.selectedVersion).name
                    };
                    //console.log(this.store.getState().projects.projectWithMetaData.options.RequireConfirmationOnUpgrade)
                    if (this.store.getState().projects.projectWithMetaData.options.RequireConfirmationOnUpgrade)
                        this.dialogManagerService.showConfirmationDialog(dialogData, onUpgradePreValidateConfirm)
                    else
                        onUpgradePreValidateConfirm();
                };
                const dialogData = {
                    title: type,
                    versions: resp.data,
                    envName: environment.name,
                    version: environment.version,
                    autoBackUpItems: this.autoBackupsItems,
                    autoRestoreItems: this.autoRestoreItems,
                    dbFlags: this.dbFlags,
                    defaultBackup: this.defaultBackup
                };
                this.dialogManagerService.showDialog(dialogData, onConfirm, UpgradePreValidateToVersionDialogComponent, 'update-to-version-dialog');
            }
            return resp;
        });
    }

    onUpdateSourceControl(environmentData) {
        let environment = environmentData.data
        this.store.dispatch({
            type: projectsActions.UPDATE_SOURCE_CONTROL,
            payload: {
                projectId: this.projectId,
                envId: environment.id
            }
        });
    }
    onExitIntegration(environmentData) {
        let environment = environmentData.data;
        this.store.dispatch({
            type: environmentsActions.EXIT_INTEGRATION,
            payload: {
                projectId: this.projectId,
                envId: environment.id,
                body: { "isIntegrationStateOn": false }
            }
        });
    }

    onSetVersion(environmentData) {
        let environment = environmentData.data
        this.store.dispatch({
            type: environmentsActions.GET_VERSIONS_FOR_SET,
            payload: { projectId: this.projectId, envId: environment.id }
        }).then((resp) => {
            if (resp.data.length === 0) {
                this.dialogManagerService.showErrorDialog({ title: '', text: this.$translate("ERROR_PACKAGE_NOT_EXIST") });
            } else {
                const onConfirm = (data) => {
                    const type = environmentsActions.SET_TO_VERSION;
                    this.store.dispatch({
                        type: type,
                        payload: {
                            projectId: this.projectId,
                            envId: environment.id,
                            packageId: String(data.selected)
                        }
                    }).then((res) => {
                        if (res.data === false) {
                            this.forceSetVersion({ projectId: this.projectId, envId: environment.id, packageId: data.selected });
                        }
                    });;
                };
                const dialogData = {
                    title: 'Set Version',
                    versions: resp.data
                };
                this.dialogManagerService.showDialog(dialogData, onConfirm, SetVersionDialogComponent, 'set-version-dialog');
            }
            return resp
        });
    }

    forceSetVersion(forceData) {
        const onConfirm = () => {
            this.store.dispatch({
                type: environmentsActions.SET_TO_VERSION,
                payload: {
                    projectId: forceData.projectId,
                    envId: forceData.envId,
                    packageId: forceData.packageId,
                    force: true
                }
            });
        };
        const dialogData = { title: 'Forcing Set Version', action: null, message: 'Requested Version Validation failed. force?' };
        this.dialogManagerService.showConfirmationDialog(dialogData, onConfirm);
    }

    HandleFileButtonClick(data) {
        var fileButton = document.querySelector('#fileButton');
        fileButton[0].click();
        data.selectedFile = fileButton[0].value;
    }


    // addScroller() {
    //     if (this._environments.length > 4) {
    //         setTimeout(() => this.scrollEnvs = true, 0);
    //     }
    // }

    dblClick(environmentData) {
        let environment = environmentData.data;
        if (this.store.getState().project.editMode) {
            try {
                this._environments.find(env => {
                    return env.id == environment.id
                }).envSelected = true;
            }
            catch { }

            this.onEditModeDblClick.emit("true")
        }
        else {
            this.onEnvDblClick.emit(environment)
        }

    }

    dblClickOnTest(environment) {
        if (this.store.getState().project.editMode)
            this.onEditModeDblClickTest.emit("true")
        else
            this.onEnvDblClick.emit(environment)
    }

    IsByTask = () => {
        return this.dplModeType === consts.deploymentType.ByTask
    }


    ngOnDestroy(): void { }



    trackByEnv(_index, item) {
        return item.id;
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/pipeline/environments-ang7/environmentType.ts